module.exports = __webpack_public_path__ + "static/media/dancing-girl.3804d477.png";